module.exports = __webpack_public_path__ + "static/media/tn.363af322.svg";